
import "./Select.css";
import { useState, useEffect } from "react";

export const Select = (props) => { 

  const [openMenu, setOpenMenu] = useState(false);
  const [openInput, setOpenInput] = useState(false);
  const [valueInput, setValueInput] = useState(props.placeholder);

  useEffect(() => {
    console.log('rendered again')
  });

  const toggleSelect = () => {
    setOpenInput(!openInput);
    setOpenMenu(!openMenu);
  };

  const items = props.options.map(item => {
    return (
      <div 
        key={item} 
        className="mySelect item"
        onMouseDown={e => {setValueInput(e.target.innerText); toggleSelect();}}
      >
      {item}
      </div>
    )
  });

  return (
    <>
    <div 
      className="mySelect" 
    >
      <div
        className={openInput ? "mySelect input open" : "mySelect input close"}
        onMouseDown={toggleSelect}
      >
        {valueInput}
      </div>
      <div className={openMenu ? "mySelect menu open" : "mySelect menu close"}>
        {items}
      </div>
    </div>
    </>
  )

} 
